/**
 * Combine event handlers; stops if a handler calls preventDefault.
 */
export function mergeHandlers(...handlers) {
  return (event) => {
    for (const handler of handlers) {
      if (typeof handler === "function") {
        handler(event);
        if (event?.defaultPrevented) break;
      }
    }
  };
}
